import { StyledTabsList, StyledTab } from './send-tabs.style';

import { storageTabsOptions } from 'lib/constants';

type TabProps = {
  label: string;
  value: string;
};

const SendTabs = ({
  tab,
  onSelect
}: {
  tab: TabProps;
  onSelect: (item: TabProps) => void;
}) => {
  return (
    <StyledTabsList>
      {storageTabsOptions.map((item) => (
        <StyledTab
          key={item.value}
          active={tab.value === item.value}
          onClick={() => onSelect(item)}
        >
          {item.label}
        </StyledTab>
      ))}
    </StyledTabsList>
  );
};

export default SendTabs;
